import angular from 'angular';

// {"options":["a","b","c"...]}
/**
 * Controla la tabla de inspecciones.
 */
CamposExtraListCtrl.$inject = [];
export default function CamposExtraListCtrl() {

    var campExtList = this;
    campExtList.claseRow = issetAndNotEmpty(campExtList.claseRow) ? campExtList.claseRow == 'true' : true;
    var teniaValor = campExtList.campoExtra.valor !== null && campExtList.campoExtra.valor.length > 0;
    campExtList.jsonOptions = angular.fromJson(campExtList.campoExtra.json);

    if (campExtList.jsonOptions.multiple && campExtList.campoExtra.valor != null && campExtList.campoExtra.valor != "")
        campExtList.campoExtra.valor = angular.fromJson(campExtList.campoExtra.valor);

    campExtList.hasError = false;

    campExtList.updateError = false;

    campExtList.validate = function () {
        if (issetAndNotEmpty(campExtList.campoExtra.valor)) {
            campExtList.hasError = false;
            campExtList.campoExtra.changed = true;
        } else if (teniaValor) {
            campExtList.hasError = true;
            campExtList.campoExtra.changed = false;
        }
    };

    campExtList.borrar = function () {
        campExtList.campoExtra.valor = null;
        campExtList.campoExtra.changed = true;
    };
}